var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.764 11.4344C13.8822 9.55198 13.599 8.60745 13.599 5.59999C13.599 2.50718 11.0923 0 8.00005 0C4.90777 0 2.40112 2.50721 2.40112 5.59999C2.40112 7.22158 2.35793 7.82692 2.13471 8.57011C1.85712 9.49598 1.28725 10.3824 0.235779 11.4344C-0.267938 11.9384 0.0888735 12.8 0.801403 12.8H5.24058L5.2003 13.2C5.2003 14.7464 6.45364 16 7.99976 16C9.54589 16 10.7992 14.7464 10.7992 13.2L10.7589 12.8H15.1984C15.9112 12.8 16.268 11.9384 15.764 11.4344ZM8.0003 15.2C6.89602 15.2 6.00058 14.3043 6.00058 13.2L6.04086 12.8H9.95926L10.0001 13.2C10 14.3043 9.10458 15.2 8.0003 15.2ZM0.801653 12C3.20112 9.59998 3.20112 7.99998 3.20112 5.59999C3.20112 2.94934 5.34965 0.799998 8.00005 0.799998C10.6504 0.799998 12.799 2.94934 12.7992 5.59999C12.7992 7.99998 12.7992 9.59998 15.1987 12H0.801653Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.48983266.svg";
export { ForwardRef as ReactComponent };